var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReduceBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_17650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.9844C18.1856 31.9844 20.2432 31.5663 22.1725 30.7301C24.102 29.8939 25.8039 28.7389 27.2784 27.2651C28.7529 25.7914 29.9085 24.0902 30.745 22.1617C31.5817 20.2333 32 18.1768 32 15.9922C32 13.8076 31.5817 11.7511 30.745 9.82265C29.9085 7.89419 28.7529 6.19306 27.2784 4.71926C25.8039 3.24547 24.0993 2.09048 22.1646 1.25429C20.23 0.418097 18.1699 0 15.9843 0C13.7987 0 11.7412 0.418097 9.81175 1.25429C7.88234 2.09048 6.183 3.24547 4.71372 4.71926C3.24444 6.19306 2.0915 7.89419 1.2549 9.82265C0.4183 11.7511 0 13.8076 0 15.9922C0 18.1768 0.4183 20.2333 1.2549 22.1617C2.0915 24.0902 3.24705 25.7914 4.72156 27.2651C6.19607 28.7389 7.89803 29.8939 9.82743 30.7301C11.7568 31.5663 13.8144 31.9844 16 31.9844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67843 17.3721C9.2183 17.3721 8.84445 17.2545 8.55687 17.0194C8.26928 16.7842 8.12549 16.4524 8.12549 16.0238C8.12549 15.5848 8.26667 15.2451 8.54903 15.0047C8.83138 14.7642 9.20785 14.644 9.67843 14.644H22.3529C22.8235 14.644 23.1974 14.7642 23.4746 15.0047C23.7516 15.2451 23.8901 15.5848 23.8901 16.0238C23.8901 16.4524 23.7463 16.7842 23.4588 17.0194C23.1712 17.2545 22.8026 17.3721 22.3529 17.3721H9.67843Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_17650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceBlack);
export default __webpack_public_path__ + "static/media/reduce-black.2edf4c11db85cf3480695f7974da95b5.svg";
export { ForwardRef as ReactComponent };